import Logger from "../utils/Logger";
import strings from "../utils/Strings";
import analytics_strings from "./analytics_strings";
import { analytics } from "./firebase_initialization";
import { logEvent } from "firebase/analytics";

export const logPageView = (pagePath: string) => {
  if (analytics) {
    if (pagePath.includes("/reset_password")) {
      pagePath = analytics_strings.analytics_path.resetPasswordPage; //Manually Adding reset Password Path Because need to remove token from it
    }
    logEvent(analytics, "page_view", {
      page_path: pagePath,
    });
  } else {
    Logger.info("Firebase Analytics is not initialized While LogPage.");
  }
};

export const logActionEvent = (
  eventName: string,
  params?: Record<string, any>,
) => {
  if (analytics) {
    if (params != null) {
      params.entityType = "Candidate";
    }
    logEvent(analytics, eventName, params);
  } else {
    Logger.info("Firebase Analytics is not initialized While LogEvent.");
  }
};
